"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import { usePromoDetailModel } from "./promoDetailPageModel";
import PromoDetailHeader from "./_cmp/PromoDetailHeader";
import PromoStatTiles from "./_cmp/PromoStatTiles";
import PromoOrdersToolbar from "./_cmp/PromoOrdersToolbar";
import PromoOrdersTable from "./_cmp/PromoOrdersTable";
import PromoDetailSkeleton from "./_cmp/PromoDetailSkeleton";
import { PromoDialog } from "../_cmp/promoForm/PromoDialog";

export default function PromoDetailPage() {
  const {
    promo,
    kpis,
    isLoading,
    showOptions,
    openForm,
    openEditForm,
    closeForm,
    handleToggleActive,
    handleDelete,
    refetch,
    orders,
    orderCount,
    isOrdersLoading,
    page,
    setPage,
    search,
    setSearch,
    showIds,
    setShowIds,
  } = usePromoDetailModel();

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PromoDetailHeader
          promo={promo}
          onEdit={openEditForm}
          onToggleActive={handleToggleActive}
          onDelete={handleDelete}
        />

        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto p-5">
          {/* min-h-full plus the flex chain below lets the orders table absorb the
              leftover page height instead of the page ending under a short table. */}
          <div className="mx-auto flex min-h-full w-full max-w-[1100px] flex-col">
            {isLoading || !promo || !kpis ? (
              <PromoDetailSkeleton />
            ) : (
              <div className="flex min-h-0 flex-1 flex-col gap-5">
                <PromoStatTiles kpis={kpis} />

                <div className="flex min-h-0 flex-1 flex-col gap-2">
                  <div className="text-[13.5px] font-semibold text-foreground">Orders</div>
                  <PromoOrdersToolbar
                    search={search}
                    onSearchChange={setSearch}
                    showIds={showIds}
                    onShowIdsChange={setShowIds}
                  />
                  <PromoOrdersTable
                    orders={orders}
                    count={orderCount}
                    page={page}
                    isLoading={isOrdersLoading}
                    onGoToPage={setPage}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <PromoDialog
        open={openForm}
        defaultPromo={promo}
        showOptions={showOptions}
        onClose={closeForm}
        onSaved={refetch}
      />
    </PageContainer>
  );
}
